var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2E2E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7831 19.1458C26.267 19.1461 26.6435 19.5226 26.6438 20.0066C26.6439 20.2485 26.5499 20.4501 26.3887 20.6113C26.2274 20.7726 26.0259 20.8665 25.7839 20.8664L20.8641 20.8641L20.8664 25.7839C20.8665 26.0259 20.7726 26.2274 20.6113 26.3887C20.4501 26.5499 20.2485 26.6439 20.0066 26.6438C19.5226 26.6435 19.1461 26.267 19.1458 25.7831L19.1435 20.8633L14.2237 20.8609C13.7397 20.8606 13.3632 20.4841 13.3629 20.0002C13.3627 19.5162 13.7389 19.1401 14.2228 19.1403L19.1426 19.1426L19.1403 14.2228C19.1401 13.7389 19.5162 13.3627 20.0002 13.3629C20.4841 13.3632 20.8606 13.7397 20.8609 14.2237L20.8632 19.1435L25.7831 19.1458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlusCircle);
export default __webpack_public_path__ + "static/media/btn-plus-circle.94c9ae8e7e4b16e1679134c4aba0c868.svg";
export { ForwardRef as ReactComponent };